'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_s_util_Left$() {
}
export { $c_s_util_Left$ as $c_s_util_Left$ };
$p = $c_s_util_Left$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_s_util_Left$;
/** @constructor */
function $h_s_util_Left$() {
}
export { $h_s_util_Left$ as $h_s_util_Left$ };
$h_s_util_Left$.prototype = $p;
$p.b = (function() {
  return "Left";
});
var $d_s_util_Left$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_s_util_Left$, "scala.util.Left$", ({
  we: 1
}));
export { $d_s_util_Left$ as $d_s_util_Left$ };
var $n_s_util_Left$;
function $m_s_util_Left$() {
  if ((!$n_s_util_Left$)) {
    $n_s_util_Left$ = new $c_s_util_Left$();
  }
  return $n_s_util_Left$;
}
export { $m_s_util_Left$ as $m_s_util_Left$ };
